var exports = {
  "R3": "xcc377c0b--9c5ed5--tooltipContainer",
  "rv": "xcc377c0b--9c5ed5--tooltipContent",
  "qW": "xcc377c0b--9c5ed5--tooltipContent--bottom",
};

module.exports = exports;
